import { createFileRoute } from '@tanstack/react-router'
import { configQuery } from '~/features/auth/queries'
import { LandingPage } from '~/features/landing/LandingPage'

export const Route = createFileRoute('/start')({
  loader: ({ context }) => void context.queryClient.prefetchQuery(configQuery),
  component: LandingPage,
})
